<ng-container
    #user="user"
    lsUser
>
    <aside
        *lsUiNgLet="user.userInfo$ | async as userInfo"
        class="menu__sidebar"
    >
        @if (!isMobile) {
            <header class="menu__header">
                <a
                    (click)="closeRedirect('/')"
                    class="menu__logo"
                >
                    <ls-picture
                        [alt]="'aerobet'"
                        [lazy]="true"
                        [src]="'event-themes/' + eventTheme + '/images/logo-desktop'"
                        [width]="140"
                        [height]="48"
                    />
                </a>

                <button
                    [hasIcon]="true"
                    [name]="'common.button-close' | translate"
                    lsUiButtonKind="basic"
                    lsUiButtonPalette="neutral-1"
                    lsUiButtonSize="small"
                    (click)="closeBurger()"
                >
                    <ls-ui-icon
                        height="24"
                        src="cross"
                        width="24"
                    />
                </button>
            </header>
        }

        <ng-container
            #mainBanner="bannerV2"
            location="new-feature-banner-sidebar"
            lsBannerV2
        >
            @if (mainBanner.items$ | async; as banners) {
                @for (ban of banners; let index = $index; track ban.id) {
                    <ls-new-feature-banner
                        [banner]="ban"
                        class="menu__banner"
                        (lsOnLinkClick)="closeMenu()"
                    />
                }
            }
        </ng-container>

        <ls-profile-info
            [user]="userInfo"
            (lsCloseRedirect)="closeRedirect($event)"
        />

        <nav class="menu__nav">
            @if (linksListOne.length) {
                <ls-section-box class="menu__list">
                    @for (link of linksListOne; track link) {
                        @if (link) {
                            <ng-container
                                *ngTemplateOutlet="linkTemplate; context: {
                                    name: link.name,
                                    url: link.url,
                                    icon: link.icon,
                                }"
                            ></ng-container>
                        }
                    }
                </ls-section-box>
            }

            @if (linksListTwo.length) {
                <ls-section-box class="menu__list">
                    @for (link of linksListTwo; track link) {
                        @if (link) {
                            <ng-container
                                *ngTemplateOutlet="linkTemplate; context: {
                                    name: link.name,
                                    url: link.url,
                                    icon: link.icon,
                                    label: link.label,
                                }"
                            ></ng-container>
                        }
                    }
                </ls-section-box>
            }
        </nav>

        <div class="menu__special-menu">
            @if (hasLuckyWin) {
                <ls-special-menu-item
                    name="common.button-lucky-spin"
                    filterColor="132 212 255"
                    iconUrl="wheel/assets/lucky-wheel-icon"
                    bgUrl="wheel/assets/lucky-wheel-bg"
                    linearGradient="linear-gradient(90deg, rgba(9, 80, 146, 0.91) 0%, rgba(0, 137, 158, 0.91) 100%)"
                    (lsOnClick)="userInfo ? openWheel() : openRegistration()"
                />
            }

            @if (hasTournaments) {
                <ls-special-menu-item
                    name="common.category-tournaments"
                    filterColor="255 216 132"
                    iconUrl="tournament/assets/tournaments-icon"
                    bgUrl="tournament/assets/tournaments-bg"
                    linearGradient="linear-gradient(90deg, rgba(151, 64, 6, 0.92) 0%, rgba(201, 124, 0, 0.92) 100%)"
                    (lsOnClick)="closeRedirect('/tournaments')"
                />
            }

            @if (hasAchievements) {
                <ls-special-menu-item
                    bgUrl="achievement/assets/achievement-bg"
                    filterColor="253 132 255"
                    iconUrl="achievement/assets/achievement-icon"
                    linearGradient="linear-gradient(0deg, rgba(37, 37, 37, 0.14) 0%, rgba(37, 37, 37, 0.14) 100%), linear-gradient(90deg, rgba(178, 27, 201, 0.90) 0%, rgba(165, 100, 250, 0.90) 100%)"
                    name="common.achievements"
                    (lsOnClick)="closeRedirect('/achievements')"
                />
            }
        </div>

        <ls-section-box class="menu__list">
            <button
                class="menu__link"
                [title]="'common.jivo' | translate"
                lsLivechatButton
            >
                <ls-ui-icon
                    height="24"
                    src="support"
                    width="24"
                />
                <span class="_system-p-sm _600">{{ "common.button-live-chat" | translate }}</span>
            </button>

            <button
                class="menu__link _choose-lang"
                lsChooseLangs
                (currentLanguageChange)="onLanguageChange($event)"
            >
                <svg
                    [title]="currentLanguage?.value"
                    height="24"
                    width="24"
                >
                    <use [attr.xlink:href]="'assets/langs/output/sprite.svg#' + (currentLanguage?.id | lowercase)"/>
                </svg>
                <span class="_system-p-sm _600">{{ ("popup.choose-langs-country-" + currentLanguage?.id) | translate }}</span>
            </button>
        </ls-section-box>
    </aside>
</ng-container>

<ng-template
    #linkTemplate
    let-name="name"
    let-url="url"
    let-icon="icon"
    let-label="label"
>
    <a
        class="menu__link"
        [routerLink]="[url | localize]"
        routerLinkActive="_active"
        (click)="closeMenu()"
    >
        <ls-ui-icon
            height="24"
            src="{{ icon }}"
            width="24"
        />
        <span class="_system-p-sm _600">{{ name | translate }}</span>

        @if (label) {
            <span class="menu__link-label _graphic-label-badge-sm">{{ label | translate }}</span>
        }
    </a>
</ng-template>
